import React from 'react';
import { cn } from '@/utils/cn';
import { getImageUrl } from '@/utils/string';
import { imageTypes } from '@/constants/types';
import ImageComponentV2 from '../Image/ImageComponentV2';
import TextSmall from '../Typography/TextSmall';

function TagBadge({ icon, label, className = '' }) {
  return (
    <div className="w-max bg-brilliant-white2 flex items-center gap-0.5 lg:gap-[4px] px-4 lg:px-10 py-4 rounded-[100px]">
      <ImageComponentV2
        src={icon ? getImageUrl(icon) : null}
        alt={label}
        className="size-[16px] lg:size-[20px]"
        type={imageTypes.icon}
        width={20}
        height={20}
        loading="lazy"
      />

      <TextSmall
        text={label}
        className={cn(
          '!text-xss lg:!text-sm text-coarse-wool font-medium whitespace-pre',
          className,
        )}
      />
    </div>
  );
}

export default TagBadge;
